module.exports = __webpack_public_path__ + "static/media/img24.00dd014a.jpg";